// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { personSchema } from '@/account/api/types';
import { dateTimeSchema } from '@/utilities/date-time-schema';
import { z } from 'zod';

// Schema for a note
export const noteSchema = z.object({
  key: z.string(),
  content: z.string(),
  createdAt: dateTimeSchema,
  lastUpdatedAt: dateTimeSchema,
  createdBy: personSchema,
  lastUpdatedBy: personSchema,
});

export type Note = z.infer<typeof noteSchema>;
